import { render } from "./Tag.vue?vue&type=template&id=60e0d04a"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"
script.render = render

export default script